/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPhotoBitcoin = createReactComponent("outline", "photo-bitcoin", "IconPhotoBitcoin", [["path", { "d": "M17 21v-6m2 0v-1.5m0 9v-1.5m-2 -3h3m-1 0h.5a1.5 1.5 0 0 1 0 3h-3.5m3 -3h.5a1.5 1.5 0 0 0 0 -3h-3.5", "key": "svg-0" }], ["path", { "d": "M15 8h.01", "key": "svg-1" }], ["path", { "d": "M13 21h-7a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5", "key": "svg-2" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l2.5 2.5", "key": "svg-3" }]]);

export { IconPhotoBitcoin as default };
//# sourceMappingURL=IconPhotoBitcoin.mjs.map
